import { pushUrlParams } from "../../../Foundation/history.js"

export const updateUrl = ( query ) => {
  pushUrlParams( query )
}

